module.exports = __webpack_public_path__ + "img/breaking_barriers.c0b0d28e.svg";